import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { moduleAdd, moduleGetSingle, moduleUpdate } from "actions/module/requests";

const ModuleEdit = (props) => {
    const [id, setId] = useState("");
    const [version, setVersion] = useState(1);

    const handleSubmit = (ev) => {
        ev.preventDefault();
        const data = {
            id,
            version
        };
        if (id) {
            props.moduleUpdate(id, data, () => {
                props.history.push("/module");
            });
        } else {
            props.moduleAdd(data, () => {
                props.history.push("/module");
            });
        }
    };

    const {
        match,
        moduleGetSingle
    } = props;
    const paramId = match && match.params && match.params.id ? match.params.id : false;
    useEffect(() => {
        if (paramId) {
            moduleGetSingle(paramId, single => {
                if (!single) {
                    return;
                }
                setId(single.id);
                setVersion(single.version);
            });
        }
    }, [paramId, moduleGetSingle]);

    return (
        <div className="w-100 p-2">
            <div className="card">
                <div className="card-header">
                    <h4>Module</h4>
                </div>
                <div className="card-body">
                    <form
                        noValidate
                        autoComplete="off"
                        onSubmit={handleSubmit}
                    >

                        <div className="mb-3">
                            <label>Module name</label>
                            <input
                                className="form-control"
                                type="text"
                                value={id}
                                placeholder="accounts"
                                onChange={ev => setId(ev.target.value)}
                            />
                        </div>

                        <div className="mb-3">
                            <label>version</label>
                            <input
                                className="form-control"
                                type="number"
                                value={version}
                                placeholder="1"
                                onChange={ev => setVersion(+ev.target.value)}
                            />
                        </div>

                        <hr/>

                        <div className="text-end">
                            <button
                                className="btn btn-success"
                                onClick={handleSubmit}
                                disabled={false}
                            >
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    loading: state.module.loading,
});

const mapStateToDispatch = dispatch => ({
    moduleAdd: bindActionCreators(moduleAdd, dispatch),
    moduleUpdate: bindActionCreators(moduleUpdate, dispatch),
    moduleGetSingle: bindActionCreators(moduleGetSingle, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ModuleEdit);



// WEBPACK FOOTER //
// ./src/views/pages/Module/edit.js